export default "/img/v12-0-0_fig2.8c5b17ec50c3725051d8133d2433a43c.png";